import { render, staticRenderFns } from "./RecommendCollections.vue?vue&type=template&id=2682fa83"
import script from "./RecommendCollections.vue?vue&type=script&lang=ts"
export * from "./RecommendCollections.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports